module.exports = __webpack_public_path__ + "media/images/benefit-bill-992e0b8e2808ca791c8e4733b7129e74.svg";